import {
    deletePendingRequest,
    getPendingRequests,
} from '../../../indexedDb/pendingRequests'

export const fetchPendingRequests = async () => {
    try {
        const pendingRequests = await getPendingRequests()
        return pendingRequests || []
    } catch (error) {
        console.error('Error fetching data from IndexedDB:', error)
        return []
    }
}

export const hasPendingRequests = async () => {
    try {
        const pendingRequests = await getPendingRequests()
        return pendingRequests.length > 0
    } catch (error) {
        console.error('Error checking pending requests:', error)
        return false
    }
}

export const handleDeleteRequest = async id => {
    try {
        await deletePendingRequest(id)
        window.dispatchEvent(new Event('indexedDBChange'))
    } catch (error) {
        console.error('Error deleting request:', error)
    }
}
